import styled from "styled-components";

const Container = styled.div`
  max-width: 640px;
  padding: 0 1em;
  margin: 0 auto;
  background: #fff;
  overflow-x: hidden;
`;

export default Container;



// WEBPACK FOOTER //
// ./src/components/Container.js